import { execFileSync } from "node:child_process";
import { join, resolve } from "node:path";

export type ExecutionContext = {
  branch: string | undefined;
  cwd: string;
  gitDir: string | undefined;
  isGitRepo: boolean;
  projectRoot: string;
  storageRoot: string;
};

function runGit(args: string[], cwd: string) {
  return execFileSync("git", args, {
    cwd,
    encoding: "utf8",
    stdio: ["ignore", "pipe", "ignore"],
  }).trim();
}

export function resolveExecutionContext(inputCwd: string): ExecutionContext {
  const cwd = resolve(inputCwd);

  try {
    const projectRoot = runGit(["rev-parse", "--show-toplevel"], cwd);
    const rawGitDir = runGit(["rev-parse", "--git-dir"], cwd);
    const gitDir = rawGitDir.startsWith("/")
      ? rawGitDir
      : resolve(projectRoot, rawGitDir);
    const branch = runGit(["branch", "--show-current"], cwd) || undefined;

    return {
      branch,
      cwd,
      gitDir,
      isGitRepo: true,
      projectRoot,
      storageRoot: join(gitDir, ".emergent-thinking"),
    };
  } catch {
    return {
      branch: undefined,
      cwd,
      gitDir: undefined,
      isGitRepo: false,
      projectRoot: cwd,
      storageRoot: join(cwd, ".git", ".emergent-thinking"),
    };
  }
}
